import { IconButton } from '@/lib';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { CampaignStepHeaderProps } from './types';

export const CampaignStepHeader: FC<CampaignStepHeaderProps> = ({ primaryButton, secondaryButton, classNames, children }) => {
  return (
    <>
      <div className={twMerge('flex items-start justify-between', classNames?.wrapper)}>
        {/* Add campaign step title or whatever you need as children */}
        {children}
        <div className={twMerge('flex gap-2.5 justify-center shrink-0', classNames?.buttonsWrapper)}>
          {secondaryButton && <IconButton {...secondaryButton} intent={secondaryButton.intent || 'secondary'} trailingIcon={secondaryButton.trailingIcon} />}
          <IconButton {...primaryButton} intent={primaryButton.intent || 'primary'} trailingIcon={primaryButton.trailingIcon} />
        </div>
      </div>
    </>
  );
};
